import React, {memo, useState} from "react";
import {useTranslation} from "react-i18next";
import {Form, Formik} from "formik";
//local
import SubHeading from "components/SubHeading";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {IconDocumentDalux} from "components/icons";
import SimpleField from "components/SimpleField";
import DaluxBanner from "assets/images/svg/dalux-banner.svg";
import {Info} from "components/Info";

const DaluxSettings = memo(
  ({settings, organization, isOwner, isAdminOwner, onUpdate}) => {
    const {t} = useTranslation();

    const [loading, setLoading] = useState(false);

    const isDaluxEnable =
      settings?.enableDaluxIntegration ?? organization?.enableDaluxIntegration;

    const daluxInitialValues = {
      daluxBaseURL: isOwner ? settings?.daluxBaseURL : "********************",
      daluxApiKey: isOwner ? settings?.daluxApiKey : "********************",
    };

    const DaluxField = ({name, label, placeholder, tooltip}) => (
      <div className="df-row-end">
        <SimpleField
          name={name}
          placeholder={t(placeholder)}
          label={t(label)}
          small
          disabled={!isOwner}
          className="input mr-2"
        />
        <Info tooltip={tooltip} centerText addClass="field-tooltip" />
      </div>
    );

    const onSubmitDaluxSettings = (values) => {
      if (!isAdminOwner) return;
      setLoading(true);
      onUpdate(values).finally(() => setLoading(false));
    };

    return (
      <div className="organization-settings__dalux-settings mb-12">
        <SubHeading title="SETTINGS_DALUX_TITLE" icon={<IconDocumentDalux />} />
        {isDaluxEnable ? (
          <React.Fragment>
            <CustomRadioSwitch
              checked={settings?.allowDalux}
              mediumText
              label={t("SETTINGS_DALUX_SWITCH_LABEL")}
              small
              addWrapperClass="mt-4"
              informationText="SETTINGS_DALUX_SWITCH_TOOLTIP"
              isActive={(checked) => onUpdate({allowDalux: checked})}
            />
            <Formik
              initialValues={daluxInitialValues}
              enableReinitialize
              onSubmit={onSubmitDaluxSettings}
            >
              {({values, dirty}) => (
                <Form>
                  <DaluxField
                    name="daluxBaseURL"
                    label="SETTINGS_DALUX_BASE_URL_NAME"
                    placeholder="SETTINGS_DALUX_BASE_URL_PLACEHOLDER"
                    tooltip="SETTINGS_DALUX_BASE_URL_TOOLTIP"
                  />
                  <DaluxField
                    name="daluxApiKey"
                    label="SETTINGS_DALUX_API_KEY_NAME"
                    placeholder="SETTINGS_DALUX_API_KEY_PLACEHOLDER"
                    tooltip="SETTINGS_DALUX_API_KEY_TOOLTIP"
                  />

                  {isOwner && (
                    <ButtonTransparent
                      type="submit"
                      loading={loading}
                      disabled={
                        !(values.daluxBaseURL?.length || values.daluxApiKey?.length) ||
                        !dirty
                      }
                      name={"SETTINGS_DALUX_SAVE_BUTTON"}
                      small
                      nonTransparent
                      addClass="organization-settings__dalux-settings__save-button"
                    />
                  )}
                </Form>
              )}
            </Formik>
          </React.Fragment>
        ) : (
          <div className="df-column wdth-250">
            <img
              src={DaluxBanner}
              className=""
              alt=""
              style={{
                height: "48px",
                margin: "20px 0px 10px",
                padding: "0",
              }}
            />

            <a className="link" href={t("URL_TO_PUBLIC_CONTACT_PAGE")} target="_new">
              {t("DALUX_SETTINGS_TEASER")}
            </a>
          </div>
        )}
      </div>
    );
  }
);

export default DaluxSettings;
